// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}
.container-smart-component .expanded {
  height: 100%;
}

.icon-and-text {
  display: flex;
  align-items: center;
  flex: 1;
  height: 150px;
  position: relative;
}

.icon {
  width: 50px;
  cursor: pointer;
}

.icon-and-text {
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: 600;
  margin-left: 10px;
}

.icon-and-text {
  width: 100%;
  display: flex;
  align-items: center;
}

/* Media query for mobile */
@media (max-width: 768px) {
  .value {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-contact/widget-contact.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECDI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADCJ;ACCI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADCR;ACEI;EACI,UAAA;ADAR;AAnBE;EACE,YAAA;AAqBJ;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;AAoBF;;AAjBA;EACE,WAAA;EACA,eAAA;AAoBF;;AAjBA;EACE,aAAA;EACA,mBAAA;AAoBF;;AAjBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAoBF;;AAjBA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAoBF;;AAjBA,2BAAA;AACA;EACE;IACE,eAAA;EAoBF;AACF","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n.container-smart-component {\n  @include external-apparance;\n\n  .expanded {\n    height: 100%;\n  }\n}\n\n.icon-and-text {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  height: 150px;\n  position: relative;\n}\n\n.icon {\n  width: 50px;\n  cursor: pointer;\n}\n\n.icon-and-text {\n  display: flex;\n  align-items: center;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-left: 10px;\n}\n\n.icon-and-text {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n/* Media query for mobile */\n@media (max-width: 768px) {\n  .value {\n    font-size: 16px;\n  }\n}\n","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
